import { registerScrollSpy } from '~/plugins/scrollspy/scrollspy';

export default defineNuxtPlugin((nuxtApp) => {
  registerScrollSpy(nuxtApp.vueApp, {
    offset: 50,
  });
});
